import React from "react";
import { Modal } from "../../../shared/Modal";
import ProofAvatar from "./ProofAvatar";
import ProofText from "./ProofText";
import Stars from "./Stars";
import AudioPlayer from "./AudioPlayer";
import SourceBadge from "./SourceBadge";

// Card-detail modal opened from any wall/list/grid widget on click.
// Reuses the app's Modal so the iframe-fullscreen postMessage bridge works
// in tight embed iframes — without it, the lightbox would be clipped.
const Lightbox = ({ proof, accent = "#3E8DFF", open, onClose }) => {
  if (!proof) return null;

  const isVideo = proof.kind === "video" && proof.video_url;
  const isAudio = proof.kind === "audio" && proof.audio_url;
  const icon = isVideo ? "video" : isAudio ? "audio" : undefined;

  return (
    <Modal
      modalOpen={open}
      setModalOpen={(v) => { if (!v) onClose(); }}
      icon={icon}
      maxWidth="max-w-2xl"
    >
      <div className="relative z-10 flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <ProofAvatar proof={proof} size={48} ringColor={accent} />
          <div className="flex-1 min-w-0">
            <div className="font-black text-base text-slate-900 truncate">
              {proof.name || "Anonymous"}
            </div>
            {(proof.contact_title || proof.contact_company_name) && (
              <div className="text-xs font-bold text-slate-500 truncate">
                {proof.contact_title}
                {proof.contact_title && proof.contact_company_name ? " · " : ""}
                {proof.contact_company_name}
              </div>
            )}
          </div>
          <SourceBadge proof={proof} color={accent} size={16} />
        </div>

        {proof.rating != null && (
          <Stars rating={proof.rating} color="#FFD23A" />
        )}

        {isVideo && (
          <div className="aspect-video w-full bg-black overflow-hidden border-[2px] border-black">
            <video
              src={proof.video_url}
              controls
              autoPlay
              className="w-full h-full object-contain"
            />
          </div>
        )}

        {isAudio && (
          <AudioPlayer
            src={proof.audio_url}
            primaryColor={accent}
            textColor="#0f172a"
            barColor="#cbd5e1"
          />
        )}

        {proof.headline && (
          <div className="font-black text-lg text-slate-900 leading-tight">
            {proof.headline}
          </div>
        )}

        {!isAudio && (
          <ProofText
            proof={proof}
            className="text-base text-slate-700 leading-relaxed"
          />
        )}
      </div>
    </Modal>
  );
};

export default Lightbox;
